import { useMemo } from 'react';
import type { DateRange } from '../../../../../shared/components/DurationSelector/types';
import { usePersistedGranularity } from '../../../../../shared/hooks/usePersistedGranularity';
import { resolveGranularity } from './resolveGranularity';

/**
 * Composes the persisted granularity mode with the range-derived resolver so a
 * dashboard wires granularity in one line: it returns the mode + setter (for the
 * GranularityToggle) and the resolved granularity (for the trend hooks).
 */
export const useResolvedGranularity = (dateRange: DateRange) => {
  const { granularityMode, setGranularityMode } = usePersistedGranularity();

  const granularity = useMemo(() => resolveGranularity(granularityMode, dateRange), [granularityMode, dateRange]);

  return { granularityMode, setGranularityMode, granularity } as const;
};
